
export const environment = {
  baseUrl: 'https://qa-backend-sadi.inversisa.net',
  baseUrlAuth: 'https://qa-backend-sadi.inversisa.net',
  auditReportApiBaseUrl: 'https://qa-backend-sadi.inversisa.net/api',
  production: true,
  dummy_JSONs: true
};
